var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconShare40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2256_11111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9732 10.271L8.58154 20.9801",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58154 20.9805L30.9732 31.6895",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06848 25.3611C11.488 25.3611 13.4495 23.3997 13.4495 20.9801C13.4495 18.5606 11.488 16.5991 9.06848 16.5991C6.64893 16.5991 4.6875 18.5606 4.6875 20.9801C4.6875 23.3997 6.64893 25.3611 9.06848 25.3611Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9738 14.6521C33.3933 14.6521 35.3547 12.6907 35.3547 10.2711C35.3547 7.85157 33.3933 5.89014 30.9738 5.89014C28.5542 5.89014 26.5928 7.85157 26.5928 10.2711C26.5928 12.6907 28.5542 14.6521 30.9738 14.6521Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9738 36.0701C33.3933 36.0701 35.3547 34.1086 35.3547 31.6891C35.3547 29.2695 33.3933 27.3081 30.9738 27.3081C28.5542 27.3081 26.5928 29.2695 26.5928 31.6891C26.5928 34.1086 28.5542 36.0701 30.9738 36.0701Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2256_11111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconShare40);
export default __webpack_public_path__ + "static/media/pictogramBeaconShare40.7217d17dc258a95aa0ccd206172aecd0.svg";
export { ForwardRef as ReactComponent };